import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChamadoEmpresaChatRoutingModule } from './chamado-empresa-chat-routing.module';
import { ChamadoEmpresaChatComponent } from './chamado-empresa-chat.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RatingModule } from 'primeng/rating';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';

@NgModule({
  declarations: [
    ChamadoEmpresaChatComponent
  ],
  imports: [
    CommonModule,
    ChamadoEmpresaChatRoutingModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    DividerModule,
    MessagesModule,
    DialogModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    OverlayPanelModule,
    TooltipModule,
    DialogModule,
    RatingModule,
    ProgressSpinnerModule,
    InputTextareaModule,
    FormatPipeModule,
    DividerModule
  ],
  providers: [ConfirmationService]
})
export class ChamadoEmpresaChatModule { }
